import React from 'react';
import { Section } from '../../components/section';
import { Column } from '../../components/column';
import { Text } from '../../components/text';
import { Divider } from '../../components/divider';
import { WrapperItem } from '../../components/wrapper-item';
import { LinkWrapper } from '../../components/link-wrapper';
import { shorthand } from '../../utils/css-utils';
import { BdiWrapper } from '../../components/bdi-wrapper';
import { cleanFont } from '../../utils/font-utils/clean-font';
export const FooterMobilePlacePromo = ({ title, cta, ctaUrl, textColor, section, iconSrc, isRtl }) => {
    const { separatorColor, fontSize, showAd } = section;
    const hasDivider = separatorColor !== 'transparent';
    const iconSize = 18;
    const iconStyle = {
        width: `${iconSize}px`,
        height: `${iconSize}px`,
        verticalAlign: 'middle',
    };
    const sectionTopPadding = hasDivider ? 5 : 35;
    const sectionBottomPadding = showAd
        ? 24
        : (section.innerPadding?.bottom || 0) + 24;
    const innerPadding = shorthand({
        ...section.innerPadding,
        top: sectionTopPadding,
        bottom: sectionBottomPadding,
    });
    const outerPadding = shorthand({
        ...section.outerPadding,
        top: 0,
        bottom: 0,
    });
    let cssClass = hasDivider
        ? 'html-emails-footer-mobile-place-section'
        : 'html-emails-footer-mobile-place-section-no-divider';
    cssClass = `${cssClass} ${section.cssClass}`;
    const direction = isRtl ? 'rtl' : 'ltr';
    return (React.createElement(WrapperItem, null,
        React.createElement(Section, { backgroundColor: section.backgroundColor, padding: outerPadding, cssClass: cssClass, borderBottom: section.borderBottom, borderLeft: section.borderLeft, borderRight: section.borderRight },
            React.createElement(Column, { padding: innerPadding, cssClass: "html-email-body-column", direction: direction },
                hasDivider && (React.createElement(Divider, { borderWidth: "1px", borderColor: separatorColor, paddingTop: "0", paddingBottom: "24px", paddingRight: "0px", paddingLeft: "0px", cssClass: "html-emails-footer-mobile-place-divider" })),
                React.createElement(Text, { color: textColor, align: "center", cssClass: "html-emails-footer-mobile-place-text", fontSize: fontSize, padding: "0 80px 10px" },
                    React.createElement("p", { className: "so-global-footer-text", style: {
                            color: textColor,
                            ...(section.fontFamily
                                ? { fontFamily: cleanFont(section.fontFamily) }
                                : {}),
                        } },
                        React.createElement(BdiWrapper, { text: title }))),
                React.createElement(Text, { align: "center", color: textColor, cssClass: "html-emails-footer-mobile-place-cta", fontSize: fontSize, padding: "0 80px" },
                    React.createElement("img", { width: iconSize, height: iconSize, src: iconSrc, alt: "", style: iconStyle }),
                    React.createElement("a", { className: "so-global-footer-text html-emails-footer-link", href: ctaUrl, style: {
                            color: textColor,
                            ...(section.fontFamily
                                ? { fontFamily: cleanFont(section.fontFamily) }
                                : {}),
                            textDecoration: 'underline',
                        }, target: "_blank" },
                        React.createElement(LinkWrapper, { fontWeight: "inherit" },
                            React.createElement(BdiWrapper, { text: cta }))))))));
};
//# sourceMappingURL=footer-mobile-place-promo.js.map